// extracted by mini-css-extract-plugin
module.exports = {"alert":"Alert_alert__NTiAW","text":"Alert_text__JEl_j"};